<template>
  <div v-if="true">
    <div style="position: relative" v-if="isPc">
      <img style="width: 100%; height: auto; display: block;" :src="'https://static.worldaic.com.cn/2023/normal/static/images/foot/footer-pc-en.jpg' + randomtag" v-if="En" alt="">
      <img style="width: 100%; height: auto; display: block;" :src="'https://static.worldaic.com.cn/2023/normal/static/images/foot/footer-pc.jpg' + randomtag" v-else alt="">
      <div v-if="En" style="position: absolute; right: 4.35rem; top: 0.94rem; display: flex;">
        <a style="width: 0.4rem; height: 0.4rem;" target="_blank" href="https://twitter.com/DONGHAOLANSHENG"></a>
        <a style="width: 0.4rem; height: 0.4rem; margin-left: 0.05rem;" target="_blank" href="https://www.facebook.com/profile.php?id=100093163388218"></a>
        <a style="width: 0.4rem; height: 0.4rem; margin-left: 0.05rem;" target="_blank" href="https://www.linkedin.com/company/worldaiconf/"></a>
        <a style="width: 0.4rem; height: 0.4rem; margin-left: 0.05rem;" target="_blank" href="https://www.youtube.com/channel/UCD1tnzQZWSfSbYTxQ8mQs7g"></a>
      </div>
    </div>
    <div style="position: relative" v-else>
      <img style="width: 100%; height: auto; display: block;" :src="'https://static.worldaic.com.cn/2023/normal/static/images/foot/footer-wap-en.jpg' + randomtag" v-if="En" alt="">
      <img style="width: 100%; height: auto; display: block;" :src="'https://static.worldaic.com.cn/2023/normal/static/images/foot/footer-wap.jpg' + randomtag" v-else alt="">
      <div v-if="En" style="position: absolute; left: 0.4rem; top: 7.74rem; display: flex;">
        <a style="width: 0.5rem; height: 0.5rem;" target="_blank" href="https://twitter.com/DONGHAOLANSHENG"></a>
        <a style="width: 0.5rem; height: 0.5rem; margin-left: 0.08rem;" target="_blank" href="https://www.facebook.com/profile.php?id=100093163388218"></a>
        <a style="width: 0.5rem; height: 0.5rem; margin-left: 0.08rem;" target="_blank" href="https://www.linkedin.com/company/worldaiconf/"></a>
        <a style="width: 0.5rem; height: 0.5rem; margin-left: 0.08rem;" target="_blank" href="https://www.youtube.com/channel/UCD1tnzQZWSfSbYTxQ8mQs7g"></a>
      </div>
    </div>
  </div>
  <div class="footer" v-else>
    <div class="content">
      <ul class="left">
        <li>
          <img src="https://static.worldaic.com.cn/2024/web/static/images/ewm.jpg" alt="">
          <p>{{ $t('ewm1') }}</p>
        </li>
        <li>
          <img src="https://static.worldaic.com.cn/2024/web/static/images/yun.jpg" alt="">
          <p>{{ $t('ewm2') }}</p>
        </li>
      </ul>
      <div class="list list3" v-if="En">
        <h2>Contact Information</h2>
        <div class="text">
          Donghao Lansheng (Group) Co.,Ltd.<br>
          T: +86-021-20893590<br>
          Add: No.850 Bocheng Road, Pudong New Area, Shanghai, 200126
        </div>
      </div>
      <div class="list list4" v-if="En">
        <h2>
          <a target="_blank" href="https://twitter.com/DONGHAOLANSHENG"><img src="https://static.worldaic.com.cn/2024/web/static/images/foot-share1.png" alt=""></a>
          <a target="_blank" href="https://www.facebook.com/profile.php?id=100093163388218"><img src="https://static.worldaic.com.cn/2024/web/static/images/foot-share2.png" alt=""></a>
          <a target="_blank" href="https://www.linkedin.com/company/worldaiconf/"><img src="https://static.worldaic.com.cn/2024/web/static/images/foot-share3.png" alt=""></a>
          <a target="_blank" href="https://www.youtube.com/channel/UCD1tnzQZWSfSbYTxQ8mQs7g"><img src="https://static.worldaic.com.cn/2024/web/static/images/foot-share4.png" alt=""></a>
        </h2>
        <div class="text">
          To stay updated with the latest news, please follow us on our<br>
          official social media platforms: Twitter, Facebook, LinkedIn and<br>
          YouTube at @WAIC-World Artificial Intelligence Conference.
        </div>
      </div>
      <div class="list list1" v-if="!En">
        <h2>{{ $t('organizer') }}</h2>
        <div class="link">
          <span v-for="item in 9" :key="item">{{ $t('organizerCont' + item) }}</span>
        </div>
      </div>
      <div class="list list2" v-if="!En">
        <h2>{{ $t('undertaker') }}</h2>
        <div class="link">
          <span v-for="item in 11" :key="item">{{ $t('undertakerCont' + item) }}</span>
        </div>
      </div>
    </div>
    <div class="beian">
        <a href="https://beian.miit.gov.cn" target="_blank">沪ICP备157017339号-5</a> <span><img src="https://static.worldaic.com.cn/2024/web/static/images/ic_badge.png" />沪公网安备 31011502008723号</span><span>{{ $t('tel') }}</span><span>{{ $t('email') }}</span><span>{{ $t('addr') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'foot',
  data() {
    return {
      
    }
  },
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .footer {
    background: #eee;
    padding: 0 1.1rem;
    
    .content {
      display: flex;
    }

    .left {
      padding: .97rem 0 0;
      display: flex;

      li {
        width: 1.8rem;
        margin-right: .2rem;

        &:last-child {
          margin-right: 0;
        }

        img {
          display: block;
          width: 1.8rem;
          height: 1.8rem;
        }

        p {
          margin-top: .2rem;
          font-size: .2rem;
          color: #727171;
          line-height: 1;
          text-align: center;
        }
      }
    }

    .list {
      flex: 1;
      margin-left: 1rem;
      padding-top: .53rem;

      h2 {
        font-size: .24rem;
        font-weight: 600;
        color: #000000;
        line-height: 1;
        padding-bottom: .2rem;
        border-bottom: 1px solid #B4B4B5;
        display: flex;

        a {
          margin-right: 5px;
          height: .24rem;
        }
        
        img {
          width: .36rem;
          height: .36rem;
          margin-top: -0.05rem;
        }
      }

      &.list3, &.list4 {
        padding-top: 1.05rem;
      }

      .text {
        font-size: .18rem;
        line-height: 2.1;
        color: #727171;
        margin-top: 1em;
      }

      .link {
        display: flex;
        flex-wrap: wrap;
        
        span {
          flex: 0 0 50%;
          font-size: .18rem;
          line-height: .27rem;
          font-weight: 400;
          color: #727171;
          margin-top: .15rem;
          min-width: 50%;
          white-space: nowrap;
        }
      }
    }

    .beian {
      padding: .4rem 1.1rem .32rem 1.1rem;
      font-size: .18rem;
      font-weight: 400;
      color: #727171;
      text-align: center;
      line-height: .4rem;
      display: flex;
      align-items: center;

      a {
        color: #727171 !important;
        text-decoration: none !important;;
      }

      span {
        line-height: .4rem;
        display: inline-flex;
        align-items: center;
        margin-left: .2rem;

        img {
          width: .2rem;
          height: auto;
          margin-right: .06rem;
        }
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .footer {
    background: #eee;
    padding: .4rem 0 .4rem;

    .left {
      padding: 0 .6rem;
      display: flex;
      justify-content: space-between;

      li {
        width: 3rem;

        img {
          display: block;
          width: 3rem;
          height: 3rem;
        }

        p {
          margin-top: .2rem;
          font-size: .24rem;
          color: #727171;
          line-height: 1;
          text-align: center;
        }
      }
    }

    .list {
      width: 6.7rem;
      margin: .8rem auto 0;

      &.list2 {
        margin-top: .6rem;
      }

      h2 {
        font-size: .32rem;
        font-weight: 600;
        color: #000000;
        line-height: 1;
        padding-bottom: .14rem;
        border-bottom: 1px solid #B4B4B5;
        display: flex;

        a {
          margin-right: .11rem;
        }
        
        img {
          width: .48rem;
          height: .48rem;
          margin-top: -0.05rem;
          display: block;
        }
      }

      .text {
        font-size: .24rem;
        line-height: 2;
        color: #727171;
        margin-top: .8em;
      }

      .link {
        display: flex;
        flex-wrap: wrap;
        
        span {
          flex: 0 0 50%;
          font-size: .24rem;
          font-weight: 400;
          color: #727171;
          margin-top: .16rem;
        }
      }
    }

    .beian {
      margin-top: .7rem;
      font-size: .24rem;
      font-weight: 400;
      color: #727171;
      line-height: 1;
      text-align: center;

      a {
        color: #727171 !important;
        text-decoration: none !important;;
      }

      span {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .24rem;
        line-height: 1.9;

        img {
          width: .24rem;
          height: auto;
          margin-right: .06rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue